import { Options } from "material-table";

const styles: Options = {
	headerStyle: {
		backgroundColor: "#dedede",
		fontWeight: "bold",
		fontSize: 14,
		textTransform: "uppercase"
	},
	rowStyle: (rowData: any) => ({
		fontFamily: "Roboto",
		fontWeight: 300,
		backgroundColor: rowData.tableData.id % 2 ? "#fff" : "#f5f5f5"
	})
}

export default styles;